module.exports = __webpack_public_path__ + "static/media/coliseu_box_5.860e2d85.jpg";